import {useEntitlement} from '@github-ui/copilot-entitlement/EntitlementContext'
import {sendEvent} from '@github-ui/hydro-analytics'
import {MeterIcon} from '@primer/octicons-react'
import {AnchoredOverlay, IconButton} from '@primer/react'
import {useState} from 'react'

import {TokenUsageInfo} from './TokenUsageInfo'

interface MeterButtonProps {
  /**
   * Chat mode reported in the token-usage telemetry event.
   */
  mode?: string
}

export function MeterButton({mode}: MeterButtonProps = {}) {
  const [isOpen, setIsOpen] = useState(false)
  const {reloadQuota} = useEntitlement()

  return (
    <AnchoredOverlay
      open={isOpen}
      onOpen={() => {
        setIsOpen(true)
        // Force a hard refresh so the popover always shows current spend,
        // bypassing the 5-minute entitlement staleTime and threshold guards.
        reloadQuota('meter_button', true)
        sendEvent('copilot_chat.activate', {
          target: 'SESSION_TOKEN_USAGE_METER',
          action: 'opened',
          mode,
        })
      }}
      onClose={() => setIsOpen(false)}
      renderAnchor={props => (
        <IconButton
          icon={MeterIcon}
          {...props}
          type="button"
          aria-label="View token usage"
          aria-haspopup="dialog"
          variant="invisible"
          size="medium"
        />
      )}
      side="outside-top"
      align="center"
      anchorOffset={22}
      alignmentOffset={4}
      overlayProps={{role: 'dialog', 'aria-label': 'Token usage'}}
      variant={{regular: 'anchored', narrow: 'fullscreen'}}
      width="medium"
    >
      <TokenUsageInfo />
    </AnchoredOverlay>
  )
}
